import { casesError } from "../config/casesError";


export const casesCreated = (caseCreate) => {
  return casesError.casesErrorsConsult(caseCreate).then(response => response)
};


